import React from "react";
import { Link } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";

const Nav = () => {
  const { user, admin, logOut } = useAuth();
  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-light pt-0 pb-0">
        <div className="container-fluid">
          <div className="d-flex flex-grow-1">
            <span className="w-100 d-lg-none d-block" />
            {/* <!-- hidden spacer to center brand on mobile --></span> */}
            <Link className="navbar-brand d-none d-lg-inline-block" to="/home">
              <div className="d-flex">
                <img
                  src="https://i.ibb.co/gRbpHvh/Pngtree-2-lipstick-cosmetics-in-carrot-5983549.png"
                  alt="logo"
                  width="80"
                  height="80"
                  className="d-inline-block align-text-top ms-5 me-10"
                />
                <h1 className="navbar-brand fw-bold fst-italic">
                  LIZA'S <br />
                  LIPSTICKS <br />
                  LTD.
                </h1>
              </div>
            </Link>
            <Link
              to="/home"
              className="navbar-brand-two mx-auto d-lg-none d-inline-block"
            >
              <img
                src="https://i.ibb.co/gRbpHvh/Pngtree-2-lipstick-cosmetics-in-carrot-5983549.png"
                alt="logo"
                width="80"
                height="80"
              />
            </Link>
            <div className="w-100 text-right">
              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#myNavbar"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
            </div>
          </div>
          <div
            className="collapse navbar-collapse flex-grow-1 text-right"
            id="myNavbar"
          >
            <ul className="navbar-nav ms-auto flex-nowrap">
              <li className="nav-item">
                <Link to="/home" className="nav-link m-2 menu-item nav-active">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/products" className="nav-link m-2 menu-item">
                  Products
                </Link>
              </li>
              {/* <li className="nav-item">
                <Link to="/login" className="nav-link m-2 menu-item">
                  Login
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/signup" className="nav-link m-2 menu-item">
                  Sign Up
                </Link>
              </li> */}
              {user?.email ? (
                <>
                  <li
                    className="nav-item nav-link m-2 menu-item"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasExample"
                    aria-controls="offcanvasExample"
                    style={{ cursor: "pointer" }}
                  >
                    Dashboard
                  </li>
                  <li className="nav-item">
                    <Link to="/home" className="nav-link m-2 menu-item">
                      <span className="fw-bold">
                        Hello, {user?.displayName}!
                      </span>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <button
                      onClick={logOut}
                      className="nav-link m-2 menu-item btn btn-custom p-2"
                    >
                      Log Out
                    </button>
                  </li>
                </>
              ) : (
                <>
                  <li className="nav-item">
                    <Link to="/login" className="nav-link m-2 menu-item">
                      Login
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/signup" className="nav-link m-2 menu-item">
                      Sign Up
                    </Link>
                  </li>
                </>
              )}
            </ul>
          </div>
        </div>
      </nav>
      {/* off canvas  */}
      <div
        className="offcanvas offcanvas-start"
        tabIndex="-1"
        id="offcanvasExample"
        aria-labelledby="offcanvasExampleLabel"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasExampleLabel">
            Dashboard
          </h5>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body">
          <div className="dropdown mt-3">
            {!admin && (
              <>
                <Link to="/pay" className="nav-link m-2 menu-item">
                  Pay
                </Link>
                <Link to="/myOrders" className="nav-link m-2 menu-item">
                  My Orders
                </Link>
                <Link to="/addReview" className="nav-link m-2 menu-item">
                  Add Review
                </Link>
              </>
            )}

            {admin && (
              <>
                <Link to="/manageAll" className="nav-link m-2 menu-item">
                  Manage All Orders
                </Link>

                <Link to="/addNew" className="nav-link m-2 menu-item">
                  Add New Product
                </Link>

                <Link to="/manageProducts" className="nav-link m-2 menu-item">
                  Manage Products
                </Link>

                <Link to="/makeAdmin" className="nav-link m-2 menu-item">
                  Make Admin
                </Link>
              </>
            )}
            <button
              onClick={logOut}
              className="nav-link m-2 menu-item btn btn-custom p-2"
              data-bs-dismiss="offcanvas"
              data-bs-target="#my-offcanvas"
            >
              Log Out
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Nav;
